module.exports = __webpack_public_path__ + "static/hero-business-sign-ee234d99dc6a1643083c527c9de11d00.png";